<template>
  <v-combobox
      v-model="inputValue"
      outlined
      :label="label"
      :items="data"
      :item-text="itemText"
      item-value="id"
      clearable
      :loading="isLoading"
      :tabindex="tabIndex"
      :rules="required ? [ruleRequired($t('utils:rules.required'))] : []"
      :search-input.sync="search"
      hide-no-data
      class="duplicate-checker"
      :autofocus="isFocused"
  >

    <template v-slot:prepend-item>
      <h6 class="mb-1 px-4 font-weight-bold">{{ $t('components:duplicate-checker.title') }}</h6>
      <v-divider></v-divider>
    </template>
    <template v-slot:item="{item}">
      <v-list-item
          :two-line="itemAdditionalInfoField ? true : false"
          :three-line="itemAdditionalInfoField && itemAdditionalInfoField2 ? true : false"
      >
        <v-list-item-content>
          <v-row justify="space-between">
            <v-col>
              <v-list-item-title class="font-weight-medium">{{item[itemText]}}</v-list-item-title>
              <v-list-item-subtitle>
                {{ item[itemAdditionalInfoField] }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{ item[itemAdditionalInfoField2] }}
              </v-list-item-subtitle>
            </v-col>
            <v-col v-show="!hideShowBtn" cols="2" align-self="center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs}">
                  <v-btn icon color="primary" @click="openItem(item)" v-on="on" v-bind="attrs">
                    <v-icon>open_in_new</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('buttons:show') }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-combobox>
</template>
<script>
import {ruleRequired} from "@/modules/core/services/rules";

export default {
  name: "DuplicateCheckField",
  props: {
    value: String, // value of the field
    label: String, // label of the field
    itemText: String, // field of item which should be displayed to the user, e.g. buildingName
    tabIndex: String, // tab index of the field to pass
    required: Boolean, // if the field is required to be filled out
    itemAdditionalInfoField: String, // field of the item which should represent additional info
    itemAdditionalInfoField2: String, // ^ for second
    hideShowBtn: Boolean, // if the show Btn should be hid or not
    triggerFocus: Boolean, // if on init the focus should be triggered
  },
  data() {
    return {
      isLoading: false,
      search: null,
      searchTimer: null,
      data: [],
      isFocused: false
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    ruleRequired,

    checkForDuplicates(term) {
      // cancel pending call
      clearTimeout(this.searchTimer);

      // delay new call 500ms
      this.searchTimer = setTimeout(() => {
        if(!term) {
          term = ''
        }

        if (term !== null && term.includes('+')) {
          // replacing '+' sign with its code
          // because plus is not encoded by encodeURI
          term = term.replace("+", "%2B")
        }

        this.$emit('checkForDuplicates', term);
      }, 500)
    },

    openItem(item) {
      this.$emit('clickedShowItem', item);
    },

    fillData(data, excludedId) {
      let foundIndex = null;

      if (excludedId) {
        foundIndex = this.getIndexWhenExist(data, excludedId);
      }

      this.data = data;
      if (foundIndex !== null) {
        this.data.splice(foundIndex, 1);
      }

      this.isLoading = false;
    },

    getIndexWhenExist(duplicateList, excludedId) {
      let foundIndex = null;

      for(let i = 0; duplicateList.length; i++) {
        if (duplicateList[i].id === excludedId) {
          foundIndex = i;
          break;
        }
      }

      return foundIndex;
    },


    reset() {
      this.data = [];
      this.search = null;
      this.inputValue = null;
    }
  },
  watch: {
    search(value) {
      if (value && this.triggerFocus) {
        this.isFocused = true;
      }

      if (!value || value === undefined || value.length <= 2) {
        this.data = [];
      }
      this.isLoading = true;
      this.inputValue = value;
      this.checkForDuplicates(value);
    }
  }
}
</script>
<style lang="scss" scoped>
.v-select-list {
  .v-divider {
    border-color: var(--v-greyTint-base);
  }

  .v-list-item:not(:last-child) {
    border-bottom: 1px solid var(--v-greyTint-base);
  }
}
</style>